/* angular */
import { Injectable } from '@angular/core';

@Injectable()
export class TextEncoderService {

	constructor() { }

	/**
	 * Buffer objects are used to represent a fixed-length sequence of bytes. Many Node.js APIs support Buffers.
	 * https://nodejs.org/api/buffer.html
	 */

	getEncodedValue(value: any) {
		return Buffer.from(value).toString('base64')

	}

	getDecodedValue(value): any {
		return Buffer.from(value, 'base64').toString('utf8');
	}
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/text-encoder.service.ts